import React from "react";

import Default from "../dashboards/Default";
import { useNavigate } from "react-router-dom";

function ProtectedPage() {
  const navigate = useNavigate();
  if(sessionStorage.getItem('token') != null){

    return (
      <React.Fragment>
        <Default />
      </React.Fragment>
    );
  } else {
    navigate('/auth/sign-in')
    return null;
  } 
  
}

export default ProtectedPage;
